import React from 'react';
import { DatePicker, TextField } from '@fluentui/react';

type BasicFormFieldsProps = {
    date: Date | null;
    setDate: (date: Date | null) => void;
    invoiceDate: Date | null;
    setInvoiceDate: (date: Date | null) => void;
    correctionHours: string;
    setCorrectionHours: (hours: string) => void;
    comment: string;
    setComment: (comment: string) => void;
};

export const BasicFormFields: React.FC<BasicFormFieldsProps> = ({
    date,
    setDate,
    invoiceDate,
    setInvoiceDate,
    correctionHours,
    setCorrectionHours,
    comment,
    setComment,
}) => {
    return (
        <>
            {/* Date Selection */}
            <DatePicker
                label="Date"
                value={date}
                onSelectDate={setDate}
                placeholder="Select date"
                ariaLabel="Select date"
                isRequired
                styles={{ root: { maxWidth: 200 } }}
            />

            {/* Invoice Date Selection */}
            <DatePicker
                label="Invoice date"
                value={invoiceDate}
                onSelectDate={setInvoiceDate}
                placeholder="Select invoice date"
                ariaLabel="Select invoice date"
                styles={{ root: { maxWidth: 200 } }}
            />

            {/* Correction Hours Input */}
            <TextField
                label="Correction Hours"
                value={correctionHours}
                onChange={(_, newValue) => setCorrectionHours(newValue || '')}
                placeholder="Enter correction hours"
                type="number"
                step="0.25"
                required
                description="Enter the hours to add or subtract (use negative values for reductions)"
                styles={{ root: { maxWidth: 200 } }}
            />

            {/* Comment Input */}
            <TextField
                label="Comment"
                value={comment}
                onChange={(_, newValue) => setComment(newValue || '')}
                placeholder="Enter a comment explaining the correction"
                multiline
                rows={3}
                required
                maxLength={1000}
            />
        </>
    );
};
